import React from 'react';
import { Link } from 'react-router-dom';
import './Download.css';

const Download: React.FC = () => {
  return (
    <section className="download" id="download">
      <div className="download__container">
        <div className="download__inner">
          <div className="download__glow" />
          <h2>App store launch<br /><span className="text-gradient">is not live yet</span></h2>
          <p>RalliPB is not currently available on the Apple App Store or Google Play. We are collecting iOS and Android beta interest while public availability is pending.</p>
          <div className="download__availability" role="status">
            There are no official App Store or Google Play download links for RalliPB at this time.
          </div>
          <div className="download__buttons">
            <a href="/beta" className="btn btn--primary btn--lg">
              Join the Beta Waitlist
            </a>
            <Link to="/support" className="btn btn--outline btn--lg">
              Contact Support
            </Link>
          </div>
          <p className="download__fine-print">
            Review our <Link to="/privacy">Privacy Policy</Link> and <Link to="/terms">Terms of Service</Link>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Download;
